import { WithChildrenProps } from "types/generalTypes";
import * as S from "./styles";

interface MainFooterProps extends WithChildrenProps {
  isTwoColumnsLayout: boolean;
}

export const MainFooter = ({
  isTwoColumnsLayout,
  children,
}: MainFooterProps) => {
  return (
    <S.Footer $isTwoColumnsLayoutHeader={isTwoColumnsLayout}>
      {children}
    </S.Footer>
  );
};
